import React, { useState, useEffect, useContext } from 'react';


import SimpleTable from '../../../components/tables/simpleTable';

import TrashModal from '../../../components/modals/trashModal';
import RecoverModal from '../../../components/modals/recoverModal';
import AddModal from '../../../components/modals/addModal';
import EditModal from '../../../components/modals/editModal';
import DeleteModal from '../../../components/modals/deleteModal';

import SearchFilter from '../../../components/filters/search';
import CustomButton from '../../../components/buttons/customButton';
import IsActiveFilter from '../../../components/filters/isActive';
import IsOrderFilter from '../../../components/filters/isOrderFilter';
import AddButton from '../../../components/buttons/addButton';
import DataFilter from '../../../components/filters/dataFilter';
import DatePicker from '../../../components/filters/datePicker';
import { selectStyles } from '../../../components/dropDown/selectStyle';
import AsyncSelect from 'react-select/async';


import { FcKindle } from "react-icons/fc";

import Loader from '../../../components/loader/loader';
import { numberFormatter } from '../../../components/formatters/numberFormatter';
import { dateFormatter } from '../../../dynamic/dateFormatter';
import { typeFormatter, paymentTypeFormatter } from '../../../components/formatters/defFormatter';
import { dateTableFormatter } from '../../../dynamic/dateFormatter';
import toast from 'react-hot-toast';

import { Space, Input, Tag, Button, Tabs } from 'antd';

import Select from 'react-select';
import { Col, Form, Row, DropdownButton, Dropdown } from 'react-bootstrap';


import { FiEdit } from "react-icons/fi";
import { FcUndo, FcRefresh, FcFlowChart, FcRules } from "react-icons/fc";
import { BiSolidTrash, BiBarcodeReader } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5";
import { FcPlus } from "react-icons/fc";
import { HiMinusCircle } from "react-icons/hi";
import { FiRotateCcw, FiPrinter, FiFilter } from "react-icons/fi";

import { DataContext } from '../../../init/getData';
import e from 'cors';




function StockValue(props) {

  let { type } = props;


  const { api, userData, settingData, warehouseOptions, productData,
    refData, selectedCompany, contentLanguages, yearId } = useContext(DataContext);
  const createdBy = parseInt(userData.id);
  const roundTo = settingData.roundTo;
  const userRole = userData.role;
  const companyId = selectedCompany.id;
  const defaultwarehouseId = userRole.warehouseId;

  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);


  const table = 'stockValue';
  const title = 'Stock Value';


  const [idRow, setIdRow] = useState([]);
  const [columnDefs, setColumnDefs] = useState([]);
  const [refreshTable, setRefreshTable] = useState(true);
  const [filter, setFilter] = useState({ search: '', isActive: 'true', type: ['simple', 'serialized'], warehouseId: defaultwarehouseId, isLowInStock: false, yearId });


  const [showCartModal, setShowCartModal] = useState(false);

  const [transaction, setTransaction] = useState(false);


  //Get Data 
  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const dataArray = ['warehouse', 'product']
        await refData(dataArray, companyId);
        setIsLoading(false);
      } catch (error) {
        console.error('Error refreshing data Contact Support');
      }
    };
    fetchData();
  }, []);


  const inStockProducts = productData.filter(product => (product.type !== 'production' && product.isStock));

  // Product Options
  const productOptions = inStockProducts?.map(item => ({
    value: item.id,
    label: `${item.sku ? ` (${item.sku}) ` : ''}  ${item.name} ${item.barcode ? ` [${item.barcode}]` : ''}`,
    unit: item.unit,
  }))

  // Load and filter account options
  const loadProductOptions = (inputValue, callback) => {
    const filteredOptions = inputValue ? productOptions.filter(option =>
      option.label.toLowerCase().includes(inputValue.toLowerCase())) : [];
    callback(filteredOptions);
  };

  const refreshTableFunction = () => {
    setRefreshTable(!refreshTable)
  }

  const selectedWarehouse = warehouseOptions?.filter(option => option.value === filter.warehouseId);



  //Excel Data
  const getExcelData = (data, getSummary) => {

    const transformedData = [];
    data.forEach(item => {

      const newItem = {
        id: item.id,
        barcode: item.barcode,
        category: item.category?.name,
        name: item.name,
        totalStock: item.totalStock,
        cost: item.cost,
        price: item.price,
        type: item.type,
        unit: item.unit,

      };

      transformedData.push(newItem);
    });



    return { transformedData };
  };


  let newColumnDefs = [
    { title: contentLanguages.ID, dataIndex: 'id', width: '6%', sorter: (a, b) => a.age - b.age },
    { title: contentLanguages.barcode, dataIndex: 'barcode' },
    { title: contentLanguages.Category, dataIndex: 'category', render: (category) => (category?.name) },
    { title: contentLanguages.Name, dataIndex: 'name' },
    { title: contentLanguages.Stock, dataIndex: 'totalStock', render: (totalStock, record) => (numberFormatter(totalStock, 2) + ' ' + record.unit) },
    { title: contentLanguages.Cost, dataIndex: 'cost', width: '8%', render: numberFormatter },
    { title: contentLanguages.Price, dataIndex: 'price', width: '8%', render: numberFormatter },
    { title: contentLanguages.Type, dataIndex: 'type' },
  ];

  useEffect(() => {
    setColumnDefs(newColumnDefs);
  }, [filter.isActive]);


  const formView = '';


  const tableFooter = (

    <div style={{ display: 'flex', justifyContent: 'space-between', position: 'absolute', left: '35%', transform: 'translateX(-50%)' }}>
      <div>

        <span className='table-footer footer-yellow'>Quantity: {numberFormatter(data?.summary?.totalProducts, 2)}</span>
        <span className='table-footer footer-red'>Low In Stock: {numberFormatter(data?.summary?.totalLowInStock, 2)} </span>
        <span className='table-footer footer-one'>Stock Value:   {numberFormatter(data?.summary?.stockCost, 2)} {settingData.currency}</span>
        <span className='table-footer footer-green'>Expected Profit: {numberFormatter(data?.summary?.totalExpectedProfit, 2)} {settingData.currency}</span>


      </div>
    </div>

  );

  const modalFooter = (
    <div style={{ textAllign: 'center' }}>

      {/* Total */}
      <Row className="mb-3" style={{ marginTop: '2%', justifyContent: 'center' }}>
        <Form.Group as={Col} style={{ display: 'flex', justifyContent: 'center' }}>
          <Form.Label></Form.Label>

        </Form.Group>
      </Row>
    </div>
  )


  // handle select change
  const handleSelectChange = (selectedOption, name) => {
    setFilter((prev) => ({
      ...prev,
      [name]: selectedOption?.value,
    }));
  };

  return (
    <div>

      {isLoading &&
        <Loader />
      }


      {!isLoading &&
        <>
          <Row className='g-2 mb-3'>

            <Col md={2}>
              <SearchFilter setFilter={setFilter} />
            </Col>

            <Col md={2}>
              <DataFilter selectedOption={selectedWarehouse} setFilter={setFilter} dataOptions={warehouseOptions} filterBy={'warehouseId'} placeHolder={'All warehouse'} />
            </Col>


            <Col md={2}>
              <AsyncSelect
                styles={selectStyles}
                cacheOptions
                isClearable={true}
                loadOptions={loadProductOptions}
                defaultOptions={[]}
                onChange={(e) => handleSelectChange(e, 'productId')}
                value={productOptions?.find(option => option.value === filter.productId)}
                noOptionsMessage={() => 'type to view'}
                placeholder={'Select Product ... '}
              />
            </Col>

            <Col md={4}>
              <Button onClick={refreshTableFunction} style={{ backgroundColor: '#22566a' }}>
                <FiFilter size={15} color='white' />
              </Button>
            </Col>

            <Col md={2} className="d-flex justify-content-end">
              <Button onClick={refreshTableFunction}>
                <FiPrinter size={18} />
              </Button>
              <Button onClick={refreshTableFunction}>
                <FiRotateCcw size={18} />
              </Button>
            </Col>

          </Row>

          <SimpleTable
            filter={filter}
            table={table}
            title={title}
            columnDefs={columnDefs}
            idRow={idRow}
            setIdRow={setIdRow}
            data={data}
            setData={setData}
            tableFooter={tableFooter}
            api={api}
            getExcelData={getExcelData}
            height={true}
            selection={true}
            refreshTable={refreshTable}
          />



        </>
      }

    </div>
  )
}

export default StockValue;
